import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import Link from 'Component/Link';
import { SearchResultFilterType } from 'Type/Search.type';

import './SearchResultsCategories.style';

/** @namespace PeggysagePwa/Component/SearchResultsCategories/Component */
export class SearchResultsCategoriesComponent extends PureComponent {
    static propTypes = {
        isMobile: PropTypes.bool.isRequired,
        filter: SearchResultFilterType.isRequired
    };

    renderTitle() {
        const { isMobile, filter: { name } } = this.props;

        if (isMobile || !name) {
            return null;
        }

        return (
            <div block="SearchResultsCategories" elem="Title">
                { name }
            </div>
        );
    }

    renderItem(item) {
        const { value_string, label, category_url } = item;

        return (
            <div block="SearchResultsCategories" elem="Item" key={ value_string }>
                <Link
                  block="SearchResultsCategories"
                  elem="ItemLink"
                  to={ category_url }
                >
                    { label }
                </Link>
            </div>
        );
    }

    renderContent() {
        const { filter: { filter_items } } = this.props;

        return (
            <div block="SearchResultsCategories" elem="Content">
                { filter_items.map(this.renderItem.bind(this)) }
            </div>
        );
    }

    render() {
        const { filter: { filter_items } } = this.props;

        if (!filter_items || !filter_items.length) {
            return null;
        }

        return (
            <div block="SearchResultsCategories">
                { this.renderTitle() }
                { this.renderContent() }
            </div>
        );
    }
}

export default SearchResultsCategoriesComponent;
